module.exports = __webpack_public_path__ + "media/images/client-2-fc7888ff1e76bb4f9db057a8db3e6fd0.png";